// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cleaning_wrapper__2V-pn"};